import * as Yup from 'yup';
import { errorMessages } from 'components/ui/formik-controls';

export const PartnerWidgetSchema = Yup.object().shape({
  isActive: Yup.boolean(),
  position: Yup.string(),
  widgetId: Yup.number().required(errorMessages.required),
});
